module.exports = __webpack_public_path__ + "static/img/partner-ywln.1356456.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-ywln.png
// module id = xlyg
// module chunks = 34